export const datatableColumn = [{
  name: 'ID',
  prop: 'id',
  index: 1,
  available: false,
  selected: false,
  display: true,
  showInDiplay: false,
  maxWidth: 50,
  width: 60
}, {
  name: 'Type',
  prop: 'type',
  index: 2,
  available: false,
  selected: false,
  display: true,
  showInDiplay: false,
  maxWidth: undefined,
  minWidth: undefined,
  width: 180
}, {
  name: 'Title',
  prop: 'title',
  index: 3,
  available: false,
  selected: false,
  display: true,
  showInDiplay: false,
  maxWidth: undefined,
  minWidth: 300,
  width: 600,
  isTreeColumn: true
}, {
  name: 'Label',
  prop: 'label',
  index: 4,
  available: false,
  selected: false,
  display: true,
  showInDisplay: true,
  maxWidth: undefined,
  minWidth: 200,
  width: 220
}, {
  name: 'State',
  prop: 'state',
  index: 5,
  available: false,
  selected: false,
  display: true,
  showInDiplay: false,
  maxWidth: undefined,
  minWidth: undefined,
  width: 130
}, {
  name: 'Iteration',
  prop: 'iteration',
  index: 6,
  available: false,
  selected: false,
  display: true,
  showInDisplay: true,
  minWidth: undefined,
  maxWidth: undefined,
  width: 120
}, {
  name: 'Creator',
  prop: 'creator',
  index: 7,
  available: false,
  selected: false,
  display: true,
  showInDisplay: true,
  maxWidth: undefined,
  minWidth: undefined,
  width: 75
}, {
  name: 'Assignees',
  prop: 'assignees',
  index: 8,
  available: false,
  selected: false,
  display: true,
  showInDisplay: true,
  maxWidth: undefined,
  minWidth: undefined,
  width: 150
}];

